import { Head, router } from "@inertiajs/react";
import Panel from "@/components/ui/Panel";
import Button from "@/components/ui/Button";
import logoFull from "@/assets/brand/logo-full.png";

// Development-only. Mirrors DevSessionsController::ROLES.
export default function DevSignIn({ roles }: { roles: string[] }) {
  return (
    <>
      <Head>
        <title>Dev sign-in</title>
      </Head>

      <div className="bg-bg bg-paper text-ink flex min-h-screen flex-col items-center justify-center gap-6 p-6">
        <img src={logoFull} alt="Boba Bash" className="h-32 w-auto" />
        <Panel title="dev-sign-in.sh" className="w-full max-w-sm">
          <p className="text-body text-ink-muted mb-5">
            Development only - pick a role to sign in as.
          </p>

          <div className="flex flex-col gap-2.5">
            {roles.map((role) => (
              <Button
                key={role}
                variant={role === "admin" ? "primary" : "secondary"}
                onClick={() => router.post("/dev/sign-in", { role })}
              >
                Sign in as {role}
              </Button>
            ))}
          </div>
        </Panel>
      </div>
    </>
  );
}
